/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .fill {
    fill: ${theme.color.disableTxt};
  }
`

export default function TelegramIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" css={Color}>
      <g id="그룹_6968" data-name="그룹 6968" transform="translate(-151 -208)">
        <rect id="사각형_6694" data-name="사각형 6694" width="18" height="18" transform="translate(151 208)" fill="#fff" opacity="0"/>
        <path id="패스_6708" className="fill" data-name="패스 6708" d="M-145.044,147.463a2.658,2.658,0,0,0-.935.226c-2.127.839-8.756,3.66-9.047,3.809-.788.4-.748.748-.013,1.029a13.966,13.966,0,0,0,1.563.481,1.682,1.682,0,0,0,1.216-.08c.427-.227,4.476-2.913,4.677-3.061s.549-.053.294.214-3.127,3.033-3.314,3.233a.526.526,0,0,0,.013.842c.374.267,3.542,2.405,3.715,2.5a.715.715,0,0,0,1.122-.441c.214-.829,1.27-7.43,1.31-7.871.03-.328.05-.881-.6-.881m0-1.5h0a2.085,2.085,0,0,1,1.569.655,2.371,2.371,0,0,1,.523,1.859c-.041.446-1.107,7.164-1.351,8.109a2.141,2.141,0,0,1-2.084,1.691,2.633,2.633,0,0,1-1.2-.306c-.362-.2-3.847-2.579-3.876-2.6a2.022,2.022,0,0,1-.709-.887,2.917,2.917,0,0,1-.732.092,4.148,4.148,0,0,1-.888-.109,15.63,15.63,0,0,1-1.785-.547,2.016,2.016,0,0,1-1.524-1.781,2.085,2.085,0,0,1,1.394-1.98c.409-.208,7.132-3.06,9.176-3.866a4.084,4.084,0,0,1,1.484-.331Z" transform="translate(309.017 65.274)" fill="#6f777e"/>
      </g>
    </svg>

  )
}
